import { CreateOrUpdateBaseService } from "../../../../common/services/createOrUpdateBase.service";
import { services } from "../../../../constants/services";

export interface institutionData {
  id: number | null;
  name: string;
  description: string;
}


export class CreateOrUpdatedInstitutionsService extends CreateOrUpdateBaseService<institutionData, any> {
  // url = `${services.userCampus}/createOrUpdateUserCampus`;
  url = `${services.institutions}`;

};

